// Single source of truth for per-client (white-label) branding.
// The active brand is fixed at build time by REACT_APP_CLIENT_REF and must NOT
// change at runtime — admin sessions carry their own clientRef for API calls,
// but public branding always follows the build.

export interface Brand {
  key: "runningmalta" | "zwa";
  /** document.title and visible product name */
  name: string;
  /** value matched against REACT_APP_CLIENT_REF ("" = default brand) */
  clientRef: string;
  logo: string;
  /** true when the logo artwork has white lettering and needs a dark chip on light surfaces */
  logoNeedsDarkBackdrop: boolean;
  favicon: string;
  /** shown on the thank-you page for support queries */
  supportEmail: string;
  /** shown in the footer */
  contactEmail: string;
  colors: {
    primary: string;
    primaryStrong: string;
    ink: string;
    headerBg: string;
    layoutBg: string;
  };
}

const runningMalta: Brand = {
  key: "runningmalta",
  name: "Running Malta",
  clientRef: "",
  logo: "/images/running_malta_logo.png",
  logoNeedsDarkBackdrop: true,
  favicon: "/favicon.ico",
  supportEmail: "info@runningmalta.com",
  contactEmail: "info@runningmalta.com",
  colors: {
    primary: "#DC2626",
    primaryStrong: "#B91C1C",
    ink: "#18181B",
    headerBg: "#0A0A0A",
    layoutBg: "#F6F6F7",
  },
};

const zwa: Brand = {
  key: "zwa",
  name: "ZW Athletic Events",
  clientRef: "ZWA",
  logo: "/images/ZWEventsLogo.png",
  logoNeedsDarkBackdrop: false,
  favicon: "/favicon_zw.ico",
  supportEmail: "zurrieqwolvesathletics@gmail.com",
  contactEmail: "zurrieqwolvesathletics@gmail.com",
  colors: {
    primary: "#1677FF",
    primaryStrong: "#0958D9",
    ink: "#18181B",
    headerBg: "#0A0A0A",
    layoutBg: "#F6F6F7",
  },
};

export const brands: Record<string, Brand> = {
  "": runningMalta,
  ZWA: zwa,
};

export const brand: Brand = brands[process.env.REACT_APP_CLIENT_REF || ""] ?? runningMalta;
